import React, { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { LOGIN } from '../constants/routes';
import AuthService from '../services/authservices';
import { AUTH_STATE_CHANGE_EVENT } from '../services/localStorageService';
import Spinner from './Spinner';

function RequireAuth() {
    const [isCheckingAuth, setIsCheckingAuth] = useState(true);
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    useEffect(() => {
        let isActive = true;
        const authService = new AuthService();

        const verifyAuth = async () => {
            const authResult = await authService.VerifyAuth();

            if (!isActive) {
                return;
            }

            setIsAuthenticated(authResult);
            setIsCheckingAuth(false);
        };

        const handleAuthChange = () => {
            setIsCheckingAuth(true);
            void verifyAuth();
        };

        void verifyAuth();
        window.addEventListener(AUTH_STATE_CHANGE_EVENT, handleAuthChange);
        window.addEventListener('storage', handleAuthChange);

        return () => {
            isActive = false;
            window.removeEventListener(AUTH_STATE_CHANGE_EVENT, handleAuthChange);
            window.removeEventListener('storage', handleAuthChange);
        };
    }, []);

    if (isCheckingAuth) {
        return (
            <div className="flex min-h-screen items-center justify-center bg-slate-50">
                <div className="flex flex-col items-center gap-3">
                    <Spinner size="lg" />
                    <p className="text-sm font-medium text-slate-600">Verifying your session...</p>
                </div>
            </div>
        );
    }

    if (!isAuthenticated) {
        return <Navigate replace to={LOGIN} />;
    }

    return <Outlet />;
}

export default RequireAuth;
